import { useRoleLayout } from "../hooks/useRoleLayout";
import SubUserPermissions from "../components/SubUserPermissions";

const SubUserPermissionsPage = () => {
  const { Layout: RoleLayout } = useRoleLayout();
  return (
    <div>
      <RoleLayout>
        <SubUserPermissions />
      </RoleLayout>
    </div>
  );
};

export default SubUserPermissionsPage;
